import React from 'react';
export function Footer() {
  return <footer className="bg-[#0A0A0A] border-t border-[#2A2A2A] py-12" data-id="element-77">
      <div className="max-w-6xl mx-auto px-6 text-center" data-id="element-78">
        <p className="text-xl font-bold text-[#F5F5F0] mb-2" data-id="element-79">CrownControl™</p>
        <p className="text-[#C8A04A] text-sm font-medium tracking-wide mb-6" data-id="element-80">
          The Non-Hormonal 10-Minute Regrowth Protocol
        </p>
        <p className="text-xs text-[#4B5563] mb-8" data-id="element-81">
          FDA-Cleared Device Class · 180-Day Guarantee · No Hormones · No
          Surgery
        </p>
        <div className="flex items-center justify-center gap-6 text-xs text-[#4B5563]" data-id="element-82">
          <a href="#" className="hover:text-[#C8A04A] transition-colors duration-200" data-id="element-83">
            Terms
          </a>
          <a href="#" className="hover:text-[#C8A04A] transition-colors duration-200" data-id="element-84">
            Privacy
          </a>
          <a href="#" className="hover:text-[#C8A04A] transition-colors duration-200" data-id="element-85">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}